import { render, staticRenderFns } from "./AdministradorModule.vue?vue&type=template&id=26d3fc7c"
import script from "./AdministradorModule.vue?vue&type=script&lang=js"
export * from "./AdministradorModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports